import {
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";

const { heading3Obj, heading4Obj, heading6Obj } = typographyStyles;
const { colors } = constants;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const comboboxCss = {
  ul: {
    width: "100%",
    zIndex: 1,
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      "@media (min-height: 550px) and (max-height: 800px)": {
        maxHeight: "30vh",
      },
    },
  },
};

export const checkboxRootCss = {
  flexDirection: "row-reverse",
  justifyContent: "flex-end",
  // negative left margin necessary to account for Angelou padding and focus-within styles
  marginLeft: "-16px",
  "*": {
    boxSizing: "content-box",
  },
};

export const checkboxLabelTextCss = [
  {
    marginRight: "8px",
    fontWeight: "bold",
    lineHeight: 1.14,
    color: colors.ui.neutral[600],
  },
  heading6Obj,
];

export const sectionHeadingTextCss = [
  {
    lineHeight: 1.2,
    marginBottom: "24px",
    marginTop: 0,
  },
  heading4Obj,
];

export const modalTitleCss = [heading3Obj];

export const scrollableBodyCss = {
  flex: 1,
};

export const scrollableBodyDropdownVisibleCss = {
  ...scrollableBodyCss,
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    "@media (min-height: 550px)": {
      overflow: "visible",
    },
  },
};

export const modalFooterButtonRowCss = {
  display: "flex",
  minHeight: "48px",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 15,
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
    ">div": {
      width: "100%",
    },
    button: {
      width: "100%",
    },
  },
};

export const modalContentWrapperCss = {
  "&&": {
    maxWidth: "750px",
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      "@media (min-height: 550px)": {
        maxHeight: 550,
        height: "auto",
      },
    },
  },
};

export const footerCss = {
  minHeight: "fit-content",
};

export const formContainerCss = {
  display: "flex",
  flexDirection: "column",
  gap: 20,
};

export const formRowCss = {
  display: "flex",
  gap: 20,
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
    flexDirection: "column",
  },
};

export const formItemCss = {
  flex: 1,
};

export const nameInputLabelCss = {
  lineHeight: "1rem",
  alignSelf: "flex-start",
};
